import apiConfig from "src/utils/apiConfig";

export const FETCH_TABLE_DATA = "vehicleAccount/fetchVehicleAccountsRequest";
export const CREATE_PAYMENT_HISTORY = "vehicleAccount/CreatePaymentRequest";
export const CREATE_PAID_PAYMENT = "vehicleAccount/CreatePaidPaymentRequest";

// export const UPDATE_TABLE_DATA = "";

export const fetchdata = (
  branchid: string | number,
  fromdate: string,
  todate: string,
  limit?: number,
  skip?: number
) => {
  const queryParams = new URLSearchParams({
    branchid: String(branchid),
    fromdate,
    todate,
  });

  if (limit !== undefined) {
    queryParams.append("limit", String(limit));
  }
  if (skip !== undefined) {
    queryParams.append("skip", String(skip));
  }

  const endpoint = `${apiConfig.GETVEHICLEACCOUNT}/?${queryParams.toString()}`;

  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: FETCH_TABLE_DATA,
    payload: apiobject,
  };
};

export const CreatePaymentRequest = (payload: any) => {
  const apiObject: any = {
    method: "POST",
    authentication: true,
    endpoint: apiConfig.CREATEPAYMENTHISTORY,
    body: payload,
  };
  return {
    type: CREATE_PAYMENT_HISTORY,
    payload: apiObject,
  };
};

export const CreatePaidPayment = (payload: any) => {
  const apiObject: any = {
    method: "POST",
    authentication: true,
    endpoint: apiConfig.CREATEPAIDPAYMENT,
    body: payload,
  };
  return {
    type: CREATE_PAID_PAYMENT,
    payload: apiObject,
  };
};

// export const updateTableData = (payload: any) => {
//   const apiObject: any = {
//     method: 'POST',
//     authentication: true,
//     endpoint: apiConfig.UPDATETABLEDATA,
//     body: payload,
//   };
//   return {
//     type: UPDATE_TABLE_DATA,
//     payload: apiObject,
//   };
// };
